import React from "react";
import AdtaDevicePage from "../devicemanagement/adtadevice/AdtaDevicePage";
import AslDevicePage from "../devicemanagement/asldevice/AslDevicePage";
import AdtaDeviceOverview from "../devicemanagement/adtadevice/AdtaDeviceOverview";
import AdtaDeviceConfiguration from "../devicemanagement/adtadevice/AdtaDeviceConfiguration";
import AdtaDeviceLogstream from "../devicemanagement/adtadevice/AdtaDeviceLogstream";
import AslDeviceOverview from "../devicemanagement/asldevice/AslDeviceOverview";
import AslDeviceConfiguration from "../devicemanagement/asldevice/AslDeviceConfiguration";
import AslDeviceLogstream from "../devicemanagement/asldevice/AslDeviceLogstream";
import ThinClientOverview from "../devicemanagement/thinclient/ThinClientOverview";
import SblDeviceOverview from "../devicemanagement/sbldevice/SblDeviceOverview";
import SblDeviceConfiguration from "../devicemanagement/sbldevice/SblDeviceConfiguration";
import ThinClientPage from "../devicemanagement/thinclient/ThinClientPage";

import LidarOverview from "../devicemanagement/lidar/LidarOverview";
import LidarManageByExceptions from "../devicemanagement/lidar/LidarManageByExceptions";
import LidarPage from "../devicemanagement/lidar/LidarPage";
import LEDControllerOverview from "../devicemanagement/ledcontroller/LEDControllerOverview";
import LEDControllerPage from "../devicemanagement/ledcontroller/LEDControllerPage";
import BinTester from "../devicemanagement/ledcontroller/bintester";
import TrafficLightPage from "../devicemanagement/trafficlightdevice/TrafficLightPage";
import TrafficLightControllerSelectPage from "../devicemanagement/trafficlightdevice/TrafficLightControllerSelectPage";
import TrafficLightControllerOverview from "../devicemanagement/trafficlightdevice/TrafficLightControllerOverview";
import AdtfDeviceOverview from "../devicemanagement/adtfdevice/AdtfDeviceOverview";
import AdtfDeviceConfiguration from "../devicemanagement/adtfdevice/AdtfDeviceConfiguration";
import AdtfDevicePage from "../devicemanagement/adtfdevice/AdtfDevicePage";
import AdtfDeviceLogstream from "../devicemanagement/adtfdevice/AdtfDeviceLogstream";
import AdtaDeviceValidation from "../devicemanagement/adtadevice/AdtaDeviceValidation";
import AslDeviceValidation from "../devicemanagement/asldevice/AslDeviceValidation";
import ZancaSortDevicePage from "../devicemanagement/zancasort/ZancaSortDevicePage";
import ZancaSortDeviceOverview from "../devicemanagement/zancasort/ZancaSortDeviceOverview";
import TesseractDevicePage from "../devicemanagement/tesseract/TesseractDevicePage";
import TesseractDeviceOverview from "../devicemanagement/tesseract/TesseractDeviceOverview";
import ZancaSortDeviceConfiguration from "../devicemanagement/zancasort/ZancaSortDeviceConfiguration";
import TesseractDeviceConfiguration from "../devicemanagement/tesseract/TesseractDeviceConfiguration";
import AutoRetrieverDeviceOverview from "../devicemanagement/autoretriever/AutoRetrieverDeviceOverview";
import AutoRetrieverDevicePage from "../devicemanagement/autoretriever/AutoRetrieverDevicePage";
import BagTrackingPage from "../devicemanagement/bagtracking/BagTrackingPage";
import ZancaSortDeviceLogstream from "../devicemanagement/zancasort/ZancaSortDeviceLogstream";
import TesseractDeviceLogstream from "../devicemanagement/tesseract/TesseractDeviceLogstream";
import AutoRetrieverDeviceLogstream from "../devicemanagement/autoretriever/AutoRetrieverDeviceLogstream";
import AsmlSubComponentSelectPage from "../devicemanagement/asmldevice/AsmlSubComponentSelectPage";
import InductCameraDevicePage from "../devicemanagement/asmldevice/InductCameraDevicePage";
import InductCameraDeviceOverview from "../devicemanagement/asmldevice/InductCameraDeviceOverview";
import PrinterDeviceOverview from "../devicemanagement/asmldevice/PrinterDeviceOverview";
import PrinterDevicePage from "../devicemanagement/asmldevice/PrinterDevicePage";
import AutoRetrieverDeviceConfiguration from "../devicemanagement/autoretriever/AutoRetrieverDeviceConfiguration";
import VerificationCameraDeviceOverview from "../devicemanagement/asmldevice/VerificationCameraDeviceOverview";
import VerificationCameraDevicePage from "../devicemanagement/asmldevice/VerificationCameraDevicePage";
import AsmlDevicePage from "../devicemanagement/asmldevice/AsmlDevicePage";
import AsmlDeviceOverview from "../devicemanagement/asmldevice/AsmlDeviceOverview";
import {IS_BAG_TRACKING_ALLOWED} from "./Util";

export const DEFAULT_ROUTES = {
    "/devicemanagement/asl": "/devicemanagement/asl/overview",
    "/devicemanagement/adta": "/devicemanagement/adta/overview",
    "/devicemanagement/adtf": "/devicemanagement/adtf/overview",
    "/devicemanagement/thinclient": "/devicemanagement/thinclient/overview",
    "/devicemanagement/sbl": "/devicemanagement/sbl/overview",
    "/devicemanagement/lidar": "/devicemanagement/lidar/overview",
    "/devicemanagement/ledcontroller": "/devicemanagement/ledcontroller/overview",
    "/devicemanagement/trafficlight": "/devicemanagement/trafficlight/overview",
    "/devicemanagement/zancasort": "/devicemanagement/zancasort/overview",
    "/devicemanagement/tesseract": "/devicemanagement/tesseract/overview",
    "/devicemanagement/autoretriever": "/devicemanagement/autoretriever/overview",
    "/devicemanagement/bagtracking": "/devicemanagement/bagtracking/overview"
};

export const BAG_TRACKING_ROUTE = [
    {
        name: "Bag Tracking",
        path: "/devicemanagement/bagtracking",
        id: "bagtracking.heading",
        component: (props) => {
            return (<BagTrackingPage history={props.history} location={props.location}/>)
        }
    }
];
export const DEVICE_MANAGEMENT_ROUTES = [
    {
        name: "ADTA",
        path: "/devicemanagement/adta",
        id: "adta.heading",
        component: (props) => {
            return (<AdtaDevicePage history={props.history} location={props.location} isADTR={false}/>)
        },
    }, {
        name: "ADTF",
        path: "/devicemanagement/adtf",
        id: "adtf.heading",
        component: (props) => {
            return (<AdtfDevicePage history={props.history} location={props.location}/>)
        },
    }, {
        name: "ASL",
        path: "/devicemanagement/asl",
        id: "asl.heading",
        component: (props) => {
            return (<AslDevicePage history={props.history} location={props.location}/>)
        },
    },{
        name: "Thin Client",
        path: "/devicemanagement/thinclient",
        id: "thinclients.heading",
        component: (props) => {
            return (<ThinClientPage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "Lidar Controller",
        path: "/devicemanagement/lidar",
        id: "lidar.heading",
        component: (props) => {
            return (<LidarPage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "LED Controller",
        path: "/devicemanagement/ledcontroller",
        id: "ledcontroller.heading",
        component: (props) => {
            return (<LEDControllerPage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "ZancaSort",
        path: "/devicemanagement/zancasort",
        id: "zancasort.heading",
        component: (props) => {
            return (<ZancaSortDevicePage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "Tesseract",
        path: "/devicemanagement/tesseract",
        id: "tesseract.heading",
        component: (props) => {
            return (<TesseractDevicePage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "Auto Retriever",
        path: "/devicemanagement/autoretriever",
        id: "autoretriever.heading",
        component: (props) => {
            return (<AutoRetrieverDevicePage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "ASML",
        path: "/devicemanagement/asml",
        id: "asml.heading",
        component: (props) => {
            return (<AsmlSubComponentSelectPage history={props.history} location={props.location}/>)
        },
    },
    ...(IS_BAG_TRACKING_ALLOWED ? BAG_TRACKING_ROUTE : [])
];

export const TRAFFIC_LIGHT_ROUTES = [
    {
        name: "Traffic Light",
        path: "/devicemanagement/trafficlight",
        id: "trafficlight.heading",
        component: (props) => {
            return (<TrafficLightPage history={props.history} location={props.location}/>)
        }
    }
]

export const ADTA = [
    {
        name: "overview",
        path: "/devicemanagement/adta/overview",
        id: "tab.overview",
        component: () => {
            return (<AdtaDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/adta/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AdtaDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/adta/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AdtaDeviceLogstream/>)
        },
    }
];

export const adtaMheValidationRoute = {
    name: "validation",
    path: "/devicemanagement/adta/validation",
    id: "tab.validation",
    component: () => {
        return (<AdtaDeviceValidation/>)
    },
}

export const ADTF = [
    {
        name: "overview",
        path: "/devicemanagement/adtf/overview",
        id: "tab.overview",
        component: () => {
            return (<AdtfDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/adtf/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AdtfDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/adtf/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AdtfDeviceLogstream/>)
        }
    }
];

export const ASL = [
    {
        name: "overview",
        path: "/devicemanagement/asl/overview",
        id: "tab.overview",
        component: () => {
            return (<AslDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/asl/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AslDeviceConfiguration/>)
        },
    },
    {
        name: "logstream",
        path: "/devicemanagement/asl/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AslDeviceLogstream/>)
        },
    }
];

export const ZANCA_SORT = [
    {
        name: "overview",
        path: "/devicemanagement/zancasort/overview",
        id: "tab.overview",
        component: () => {
            return (<ZancaSortDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/zancasort/configuration",
        id: "tab.configuration",
        component: () => {
            return (<ZancaSortDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/zancasort/logstream",
        id: "tab.logstream",
        component: () => {
            return (<ZancaSortDeviceLogstream/>)
        },
    }
];

export const TESSERACT = [
    {
        name: "overview",
        path: "/devicemanagement/tesseract/overview",
        id: "tab.overview",
        component: () => {
            return (<TesseractDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/tesseract/configuration",
        id: "tab.configuration",
        component: () => {
            return (<TesseractDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/tesseract/logstream",
        id: "tab.logstream",
        component: () => {
            return (<TesseractDeviceLogstream/>)
        },
    }
];

export const AUTO_RETRIEVER = [
    {
        name: "overview",
        path: "/devicemanagement/autoretriever/overview",
        id: "tab.overview",
        component: () => {
            return (<AutoRetrieverDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/autoretriever/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AutoRetrieverDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/autoretriever/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AutoRetrieverDeviceLogstream/>)
        },
    }
];

export const ASML_SUB_COMPONENT_ROUTES = [
    {
        name: "INDUCT CAMERA",
        path: "/devicemanagement/asml/inductcamera",
        id: "asml.inductCamera.heading",
        component: (props) => {
            return (<InductCameraDevicePage history={props.history} location={props.location}/>)
        },
    }, {
        name: "PRINTER",
        path: "/devicemanagement/asml/printer",
        id: "asml.printer.heading",
        component: (props) => {
            return (<PrinterDevicePage history={props.history} location={props.location}/>)
        },
    },
    {
        name: "VERIFICATION CAMERA",
        path: "/devicemanagement/asml/verificationcamera",
        id: "asml.verificationcamera.heading",
        component: (props) => {
            return (<VerificationCameraDevicePage history={props.history} location={props.location}/>)
        },
    },
    {
        name: "ASML",
        path: "/devicemanagement/asml/asml",
        id: "asml.asml.heading",
        component: (props) => {
            return (<AsmlDevicePage history={props.history} location={props.location}/>)
        },
    }
];

export const INDUCT_CAMERA = [
    {
        name: "overview",
        path: "/devicemanagement/asml/inductcamera/overview",
        id: "tab.overview",
        component: () => {
            return (<InductCameraDeviceOverview/>)
        }
    }
];

export const PRINTER = [
    {
        name: "overview",
        path: "/devicemanagement/asml/printer/overview",
        id: "tab.overview",
        component: () => {
            return (<PrinterDeviceOverview/>)
        }
    }
];

export const VERIFICATION_CAMERA = [
    {
        name: "overview",
        path: "/devicemanagement/asml/verificationcamera/overview",
        id: "tab.overview",
        component: () => {
            return (<VerificationCameraDeviceOverview/>)
        }
    }
];

export const ASML = [
    {
        name: "overview",
        path: "/devicemanagement/asml/asml/overview",
        id: "tab.overview",
        component: () => {
            return (<AsmlDeviceOverview/>)
        }
    }
];


export const aslMheValidationRoute = {
    name: "validation",
    path: "/devicemanagement/asl/validation",
    id: "tab.validation",
    component: () => {
        return (<AslDeviceValidation/>)
    },
}

export const THIN_CLIENTS = [
    {
        name: "overview",
        path: "/devicemanagement/thinclient/overview",
        id: "tab.overview",
        component: () => {
            return (<ThinClientOverview/>)
        },
    }
];

export const SBL = [
    {
        name: "overview",
        path: "/devicemanagement/sbl/overview",
        id: "tab.overview",
        component: () => {
            return (<SblDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/sbl/configuration",
        id: "tab.configuration",
        component: () => {
            return (<SblDeviceConfiguration/>)
        },
    }
];

export const LIDARS = [
    {
        name: "overview",
        path: "/devicemanagement/lidar/overview",
        id: "tab.overview",
        component: () => {
            return (<LidarOverview/>)
        },
    },
    {
        name: "manageByExceptions",
        path: "/devicemanagement/lidar/managebyexceptions",
        id: "tab.managebyexceptions",
        component: () => {
            return (<LidarManageByExceptions/>)
        }
    }
];

export const TRAFFIC_LIGHTS = [
    {
        name: "overview",
        path: "/devicemanagement/trafficlight/overview",
        id: "tab.overview",
        component: () => {
            return (<TrafficLightControllerOverview/>)
        },
    },
    {
        name: "trafficlight",
        path: "/devicemanagement/trafficlight/lightControls",
        id: "tab.trafficlight",
        component: () => {
            return (<TrafficLightControllerSelectPage/>)
        },
    }
];

export const LED_CONTROLLERS = [
    {
        name: "overview",
        path: "/devicemanagement/ledcontroller/overview",
        id: "tab.overview",
        component: () => {
            return (<LEDControllerOverview/>)
        }
    },
    {
        name: "testing",
        path: "/devicemanagement/ledcontroller/testing",
        id: "tab.testing",
        component: () => {
            return (<BinTester/>)
        }
    }
];



// WEBPACK FOOTER //
// ./src/components/util/RouteConstants.js